var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCapital = function SvgCapital(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9127 9H7.80865C6.27152 9 5 10.2715 5 11.8086V24.2258C5 25.763 6.27152 27.0345 7.80865 27.0345H27.9127C29.4498 27.0345 30.7213 25.763 30.7213 24.2258V11.8086C30.7213 10.2715 29.4498 9 27.9127 9ZM7.80865 9.88694H27.9127C28.9775 9.88694 29.8344 10.7438 29.8344 11.8086V12.8434H5.88694V11.8086C5.88694 10.7438 6.74385 9.88694 7.80865 9.88694ZM29.8344 13.7304V16.3912H5.88694V13.7304H29.8344ZM27.9127 26.1475H7.80865C6.74385 26.1475 5.88694 25.2906 5.88694 24.2258V17.2781H29.8344V24.2258C29.8344 25.2906 28.9775 26.1475 27.9127 26.1475Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 20.53H13.3074V21.417H8.66602V20.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 22.3042H17.7421V23.1911H8.66602V22.3042Z"
  })));
};
export default SvgCapital;